import appData from '@/helpers/app-data'
import axios from 'axios'
import airbrake from '@/helpers/airbrake'

const MAX_CACHE_SIZE = 40

const provider = appData.get('provider')

// Bootstrap one-click path if Provider exists
if (provider) {
  provider.one_click_path = appData.get('one_click_path')
}

const state = {
  provider: provider,
  cachedProviders: provider ? [provider] : [],
  loading: !provider,
  error: null
}

const findProvider = (namespace) => {
  const results = state.cachedProviders.filter(function (provider) {
    return provider.namespace == namespace
  })
  return results.length ? results[0] : null
}

const getters = {
  serviceTypeGroups () {
    const stgs = state.provider && state.provider.service_types && state.provider.service_types.filter(function (st) {
      return st.parent_id == null
    })
    return stgs
  },
  serviceTypes () {
    const sts = state.provider && state.provider.service_types && state.provider.service_types.filter(function (st) {
      return st.parent_id != null
    })
    return sts
  },
  conciseProviderName () {
    return state.provider && (state.provider.short_name || state.provider.name)
  },
  questions () {
    return state.provider && state.provider.anecdotes && state.provider.anecdotes.filter(function (anecdote) {
      return anecdote.name == 'question'
    })
  },
  factoids () {
    return state.provider && state.provider.anecdotes && state.provider.anecdotes.filter(function (anecdote) {
      return anecdote.name == 'factoid'
    })
  }
}

const mutations = {
  SET_PROVIDER (state, provider, skipCache = false) {
    state.provider = provider
    // Store previously viewed providers
    if (!skipCache && !findProvider(state.provider.namespace)) {
      state.cachedProviders.push(state.provider)
      // If cached providers is larger than max cache, remove the oldest
      if (state.cachedProviders.length > MAX_CACHE_SIZE) {
        state.cachedProviders.shift()
      }
    }
  },
  LOADING (state) {
    state.loading = true
  },
  DONE (state) {
    state.loading = false
  },
  SET_ERROR (state, error) {
    state.error = error
  }
}

const actions = {
  getProvider ({commit}, options) { // vuex actions take at most one argument, that's why we need the options object
    let providerNamespace
    let skipCache = false
    if (typeof options === 'string') {
      providerNamespace = options
    } else if (typeof options === 'object') {
      providerNamespace = options.providerNamespace
      skipCache = !!options.skipCache
    }

    commit('SET_ERROR', null)
    if (!skipCache && findProvider(providerNamespace)) {
      commit('SET_PROVIDER', findProvider(providerNamespace))
    } else {
      commit('LOADING')
      return axios.get(`/provider_info/${providerNamespace}`)
        .then((response) => {
          commit('SET_PROVIDER', response.data, skipCache)
          commit('DONE')
        })
        .catch(error => {
          commit('SET_ERROR', error)
          commit('DONE')
          airbrake.notify(error)
        })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./frontend/src/store/modules/providers/index.js